import React, { useEffect, useState } from "react";
import "./Cii.css";
import LabelValue from "../../../components/LabelValue";
import logo from "../../../images/logo.jpeg";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { DatePicker, Select } from "antd";
import { SuccessToast } from "../../../widgets/AppToast";
import dayjs from "dayjs";

const CIICalculationList = () => {
  const [filteredData, setFilteredData] = useState(null);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);
  const [selectedYear, setSelectedYear] = useState(dayjs().year());

  useEffect(() => {
    GET_SHIP_LIST();
  }, []);

  const GET_SHIP_LIST = async () => {
    try {
      const res = await post(ApiURL.list_ships_view_com, new FormData());
      if (res?.status === true) {
        set_ship_table_list(res?.ships);
        const defaultShipId = res?.ships[0]?.id;
        set_ship_id(defaultShipId);
        GET_CII_CALCULATION_LIST(defaultShipId, selectedYear);
      }
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const GET_CII_CALCULATION_LIST = async (ship_id, year) => {
    try {
      const formData = new FormData();
      formData.append("ship_id", ship_id);
      formData.append("year", year);
      const res = await post(ApiURL.cii_calculated_details_com, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data);
        SuccessToast("Success Message", res?.message);
      }
    } catch (error) {
      console.error("Error fetching Staff list:", error);
    }
  };

  useEffect(() => {
    if (ship_id && selectedYear)
      GET_CII_CALCULATION_LIST(ship_id, selectedYear);
  }, [ship_id, selectedYear]);

  const handleYearChange = (date) => {
    setSelectedYear(date ? date.year() : null);
  };

  const shipDetails = [
    { label: "IMO Number", value: filteredData?.ship_details?.imo_number },
    { label: "Ship Name", value: filteredData?.ship_details?.vessel_name },
    {
      label: "Ship Type",
      value: filteredData?.ship_details?.ship_type,
      highlight: true,
    },
    { label: "Deadweight", value: filteredData?.ship_details?.deadweight },
    {
      label: "Gross Tonnage",
      value: filteredData?.ship_details?.gross_tonnage,
    },
  ];

  const fuelConsumption = [
    {
      label: "Diesel/Gas Oil",
      value: filteredData?.fuel_consumption?.DIESEL_GAS_OIL,
    },
    { label: "HSFO", value: filteredData?.fuel_consumption?.HSFO },
    { label: "VLSFO", value: filteredData?.fuel_consumption?.VLSFO },
    { label: "LPG (Propane)", value: filteredData?.fuel_consumption?.LPG },
    { label: "LPG (Butane)", value: filteredData?.fuel_consumption?.LPGB },
    { label: "LNG", value: filteredData?.fuel_consumption?.LNG },
    { label: "Methanol", value: filteredData?.fuel_consumption?.METHANOL },
    { label: "Ethanol", value: filteredData?.fuel_consumption?.ETHANOL },
  ];

  const otherDetails = [
    {
      label: "Distance Travelled (nm)",
      value: filteredData?.distance_travelled,
    },
    { label: "CO2 EMISSION", value: filteredData?.co_emitted },
    { label: "Attained CII", value: filteredData?.attained_cii },
    { label: "CII ref", value: filteredData?.cii_ref },
    { label: "Required CII", value: filteredData?.req_cii },
    { label: "Rating Year", value: filteredData?.rating_year, highlight: true },
    {
      label: "Attained CII / Required CII",
      value: filteredData?.rating,
      highlight: true,
    },
    { label: "CII RATING", value: filteredData?.rating_category },
  ];

  return (
    <>
      {/* Ship Select + Year Picker */}
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              GET_CII_CALCULATION_LIST(value, selectedYear);
            }}
          >
            {ship_table_list?.map(
              (ship) =>
                !ship.soft_delete && (
                  <Select.Option key={ship.id} value={ship.id}>
                    {ship.vessel_name}
                  </Select.Option>
                )
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px 5px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3 className="mb-0">CII Calculation - Cargo Ship</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div className="d-flex align-items-center">
            <label className="block-label" style={{ marginRight: "10px" }}>
              Select Year
            </label>

            <DatePicker
              picker="year"
              format="YYYY"
              value={selectedYear ? dayjs(`${selectedYear}`, "YYYY") : null}
              onChange={handleYearChange}
              style={{ width: 290 }}
              disabledDate={(current) => {
                if (!current) return false;
                const minYear = dayjs().year() - 3;
                const maxYear = dayjs().year() + 3;
                return current.year() < minYear || current.year() > maxYear;
              }}
            />
          </div>
        </div>
      </div>

      {/* CII Card */}
      <div className="cii_cii-container">
        <div className="cii_header">
          <div className="cii_header-left">
            <span>CII Calculation</span>
          </div>
          <div className="cii_header-right">
            <div className="logo-placeholder">
              <img
                src={logo}
                alt="MarineBytes Logo"
                style={{ height: "70px" }}
              />
            </div>
            <div>Cen Sec Neep oree Eecorathg</div>
          </div>
        </div>

        <div className="cii_table-container">
          <div className="cii_section-header">Ship Particular</div>
          {shipDetails.map((item, i) => (
            <LabelValue
              key={i}
              label={item.label}
              value={item.value}
              highlight={item.highlight}
            />
          ))}

          <div className="cii_section-header">Fuel Consumption (ton)</div>
          {fuelConsumption.map((item, i) => (
            <LabelValue
              key={i}
              label={item.label}
              value={item.value}
              highlight={item.highlight}
            />
          ))}

          <div className="cii_section-header"></div>
          {otherDetails.map((item, i) => (
            <LabelValue
              key={i}
              label={item.label}
              value={item.value}
              highlight={item.highlight}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CIICalculationList;
